import { Tabs } from "antd";
import styled from "styled-components";

import { Palette } from "../../../../core/styles/theme";
import { formTabStyle } from "./Styles";

const FormTabAntStyled = styled(Tabs)`
    &.ant-tabs {
        color: black;
        font-family: "AeviFont";
        font-size: 11pt;
    }

    &.ant-tabs .ant-tabs-tab:hover {
        color: black;
    }

    &.ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
        color: black;
        font-size: 11pt;
    }

    &.ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn:active {
        color: black;
    }

    /* Ink bar is positioned relative to the whole (potentially multi-row) nav list,
       so it cannot track an active tab that isn't on the last row. Replace it with a
       per-tab underline that doesn't rely on the tab's row position. */
    &.ant-tabs .ant-tabs-ink-bar {
        display: none;
    }

    &.ant-tabs .ant-tabs-tab.ant-tabs-tab-active {
        box-shadow: inset 0 -2px 0 0 ${Palette.HeroGreen};
    }

    &.ant-tabs-top > .ant-tabs-nav::before {
        border-bottom: none;
    }

    /* Wrap overflowing tabs onto additional lines instead of hiding them behind
       antd's "more" dropdown. */
    &.ant-tabs .ant-tabs-nav-wrap {
        overflow: visible;
        white-space: normal;
    }

    /* antd spaces tabs using margin-left on every tab but the first
       (.ant-tabs-tab + .ant-tabs-tab). On a wrapped row, the first tab of that
       row still matches that sibling selector, so it inherits the same
       margin-left and ends up indented relative to the row above. Use gap
       on the flex container instead so spacing never depends on row position. */
    &.ant-tabs .ant-tabs-tab + .ant-tabs-tab {
        margin: 0;
    }

    &.ant-tabs .ant-tabs-nav-list {
        flex-wrap: wrap;
        width: 100%;
        gap: 4px var(--ant-tabs-horizontal-item-gutter, 32px);
    }

    &.ant-tabs .ant-tabs-nav-operations {
        display: none;
    }
`;

const FormTabStyled = styled.div`
    ${formTabStyle};
`;
export const FormTab = styled(FormTabAntStyled).attrs(() => ({ className: "aevi-form-tab" as string }))``;
export const FormTabHtml = styled(FormTabStyled).attrs(() => ({ className: "aevi-form-tab" as string }))``;
export const FormTabActiveHtml = styled(FormTabStyled).attrs(() => ({ className: "aevi-form-tab aevi-form-tab-active" as string }))``;
